import React from 'react';
import "./Header.css";
import prevIcon from "../../assets/icons/coloredPrev.svg";
import {useNavigate} from "react-router-dom";

export default function Header(props) {

    const navigate = useNavigate();
 
 
    const navigateTo = ()=>{
        if(props.movetoHotel==="movetoHotel"){
            navigate(`/bookings/${props.bookingId}`)
        }else{
            {props.bookings ? navigate("/bookings") : navigate("/bookings",{state : {activeRequests : "requests"}}) }
        }
    }
 

  return (
    <div className="header">
        <div className="header-content">
            <div className="prevIcon">
                <img src={prevIcon} alt="" onClick={navigateTo} /> 
            </div>
            <div className="header-data">
                <h6>
                    {props.title}
                </h6>
                <p>
                    {props.para}
                </p>
            </div>
        </div>
    </div>
  )
}
